// extracted by mini-css-extract-plugin
module.exports = {"schoolName":"selected-school_schoolName__1IJK2","teamsList":"selected-school_teamsList__1F0yv"};